module.exports = __webpack_public_path__ + "assets/img/lung_chart_fr.8b04e52a.png";